module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.validToken) ? _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.' + _vm.type + '.msg')))])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.' + _vm.type + '.password')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputRetypePassword"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.' + _vm.type + '.retypePassword')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retypePassword),
      expression: "retypePassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputRetypePassword",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.retypePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retypePassword = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitData($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.' + _vm.type + '.confirmButtonMsg')))]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.statusMsg))])])])]) : _vm._e(), _vm._v(" "), (!_vm.validToken) ? _c('div', {
    staticClass: "help-block text-center"
  }, [_vm._v("\n    " + _vm._s(_vm.statusMsg) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-885afe44", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-885afe44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/authentication/SetPassword.vue
// module id = 1424
// module chunks = 1